import { useLocalSearchParams } from 'expo-router'

import { XMRPMScreen } from '@/src/features/rosario/ui/XMRPMScreen'
import { filterSearchParams } from '@/src/general/utils/filterSearchParams'

export default () => {
  const searchParams = useLocalSearchParams()
  const { redirect } = filterSearchParams<{ redirect: string }>(searchParams)

  return <XMRPMScreen redirect={redirect} />
}
